<script>
  import { DateTime } from 'luxon'

  import { clientList$, memberList$, projectHistory$ } from '../store.js'
  import FormGateway from '../components/googleForm/FormGateway.svelte'
  import Input from '../components/googleForm/Input.svelte'
  import ListInput from '../components/googleForm/ListInput.svelte'
  import RadioInput from '../components/googleForm/RadioInput.svelte'
  import ButtonListInput from '../components/googleForm/ButtonListInput.svelte'
  import CombinedCheckbox from '../components/googleForm/CombinedCheckbox.svelte'
  import TextArea from '../components/googleForm/TextArea.svelte'
  import Select from '../components/googleForm/Select.svelte'

  // 開発中はrequiredを無効にする
  const required = __DEV__ ? undefined : 'required'
  // const required = 'required' // 開発中にrequiredテストをしたいときはこちらを有効にする

  // 選択中のクライアント社名
  let client

  // 選択中のメンバー一覧
  let members = []

  let supporters

  $: membersCount = members.length + Number(supporters)

  // datalist用の社名リスト。サジェストと台帳のリストをマージして提供
  $: clients = $clientList$
    ? $projectHistory$
      ? [...new Set([...Object.keys($projectHistory$), ...$clientList$])]
      : $clientList$
    : []

  // datalist用の工事名リスト
  $: projects = $projectHistory$
    ? $projectHistory$[client]
      ? $projectHistory$[client].map(([project]) => project)
      : []
    : []
</script>

<h1>作業日報システム</h1>

<FormGateway
  topic="fukudakg-report"
  message="報告を受け付けました。今日も一日お疲れ様でした！"
>
  <div class="box">
    <ButtonListInput
      id="reporter"
      name="報告者名"
      label="報告者名"
      placeholder="報告者名"
      list={$memberList$}
      isLoading={!$memberList$}
      {required}
    />
  </div>

  <div class="box">
    <Input
      type="date"
      id="reportDate"
      name="日付"
      label="日付"
      value={DateTime.local().toFormat('yyyy-MM-dd')}
      {required}
    />

    <Input
      type="time"
      id="startTime"
      name="開始時刻"
      label="開始時刻"
      value="08:00"
    />
    <Input
      type="time"
      id="endTime"
      name="終了時刻"
      label="終了時刻"
      value="17:00"
    />
  </div>

  <div class="box">
    <ListInput
      id="client"
      name="会社名"
      label="会社名"
      placeholder="会社名"
      list={clients}
      isLoading={!$clientList$}
      bind:value={client}
      {required}
    />

    <ListInput
      id="project"
      name="工事名"
      label="工事名"
      placeholder="工事名"
      list={projects}
      isLoading={!$projectHistory$}
      {required}
    />

    <TextArea
      id="task"
      name="作業内容"
      label="作業内容"
      placeholder="作業内容"
      {required}
    />

    <RadioInput
      id="kind"
      name="工事種別"
      label="種別"
      values={['常用', '契約', '追加', '未定']}
      {required}
    />
  </div>

  <div class="box">
    <CombinedCheckbox
      id="members"
      name="メンバー"
      label="メンバー"
      values={$memberList$}
      isLoading={!$memberList$}
      bind:checked={members}
    />
    <!-- 応援人数 -->
    <Select
      id="supporters"
      label="応援人数"
      name="応援人数"
      options={[1, 2, 3, 4, 5]}
      bind:value={supporters}
    />
    <!-- 人数カウント表示 -->
    <div class="content">
      <hr />
      <div class="has-text-right">
        計 <span data-testid="membersCount" class="has-text-weight-bold"
          >{membersCount}</span
        > 名
      </div>
    </div>
    <!-- 人数送信 hidden input -->
    <input
      type="text"
      name="人数"
      data-testid="membersCountHiddenInput"
      value={membersCount}
      hidden
    />
  </div>

  <div class="box">
    <Select id="cars" label="乗用車" name="乗用車" options={[1, 2, 3, 4, 5]} />

    <CombinedCheckbox
      id="vehicles"
      name="工事車両"
      label="工事車両"
      values={['トラック1.5t', 'Wキャブ3t', 'ユニック4t']}
    />
  </div>

  <div class="box">
    <CombinedCheckbox
      id="misc"
      name="その他"
      label="その他"
      values={['夜勤']}
    />

    <TextArea
      id="memo"
      name="メモ"
      label="メモ"
      placeholder="※その他の報告をここに記入"
    />
  </div>
</FormGateway>
